import { render, staticRenderFns } from "./CardWrapper.vue?vue&type=template&id=4442acea&"
import script from "./CardWrapper.vue?vue&type=script&lang=js&"
export * from "./CardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CardWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports